/* eslint-disable no-param-reassign */
/* eslint-disable new-cap */
import html2canvas, { Options } from 'html2canvas';
import html2pdf from 'html2pdf.js';
import { jsPDF } from 'jspdf';

export type IDownloadImageType = 'jpeg' | 'png' | 'image' | 'pdf';

export const CAPTURE_REMOVE_CLASS_NAME = 'dbi-capture__text-overflow-processor-on';
export const CAPTURE_EXPEND_CLASS_NAME = 'dbi-capture__text-overflow-processor-off';
const DEFAULT_FILE_NAME = '页面截屏';

const getImageFileSuffix = (type: IDownloadImageType) => {
  if (type === 'pdf') return 'jpeg';
  if (type === 'image') return 'png';
  return type;
};

export const downloadImage = (cfg: {
  url: string;
  fileName?: string;
}) => {
  const url = cfg?.url || '';
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  const iframe = document.createElement('iframe');
  const linker = document.createElement('a');
  iframe.style.display = 'none';
  linker.setAttribute('href', url);
  linker.setAttribute('download', fileName);
  document.body.appendChild(iframe);
  linker.click();
  document.body.removeChild(iframe);
};

export const downloadPDF = (cfg: {
  url: string;
  width: number;
  height: number;
  fileName?: string;
}) => {
  const url = cfg?.url || '';
  const width = cfg?.width;
  const height = cfg?.height;
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  const pdf = new jsPDF(width >= height ? 'l' : 'p', 'px', [width, height]);
  pdf.addImage(url, 'JPEG', 0, 0, width, height);
  pdf.save(`${fileName}.pdf`);
};

export const downloadPDFNew = async (cfg: {
  canvas: HTMLCanvasElement;
  fileName?: string;
}) => {
  const canvas = cfg?.canvas;
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  return html2pdf()
    .set({
      margin: 0,
      image: {
        type: 'jpeg',
        quality: 1,
      },
      thenExternal: () => {
      },
    })
    .from(canvas, 'canvas')
    .toPdf()
    .save(`${fileName}.pdf`);
};

export const captureNode = async (cfg: {
  type?: IDownloadImageType;
  node: HTMLElement;
  nodeOptions?: {
    width?: number;
    height?: number;
    othersOptions?: Record<string, string>;
  };
  options?: Partial<Options>;
  fileName?: string;
}) => {
  const type = cfg?.type || 'image';
  const node = cfg?.node;
  const nodeOptions = cfg?.nodeOptions || {};
  const options = cfg?.options || {};
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  const { onclone, ...remainOptions } = options || {};
  
  // 优先使用传入的固定尺寸，如果没有则使用计算样式
  const width = nodeOptions?.width || parseFloat(getComputedStyle(node).getPropertyValue('width'));
  const height = nodeOptions?.height || parseFloat(getComputedStyle(node).getPropertyValue('height'));

  const canvas = await html2canvas(node || document.body, {
    useCORS: true,
    // 优先采用真实 DPR，避免小数 DPR 带来的采样模糊
    scale: window.devicePixelRatio,
    imageTimeout: 60 * 1000,
    backgroundColor: '#fff',
    width,
    height,
    windowWidth: width,
    windowHeight: height,
    onclone(document, element) {
      if (!element) return;
      if (nodeOptions?.othersOptions) {
        Object.keys(nodeOptions.othersOptions).forEach((item) => {
          const el = element.querySelectorAll<HTMLElement>(`.${item}`);
          el?.forEach((t) => {
            t.style.cssText = nodeOptions.othersOptions?.[item] || '';
          });
        });
      }
      const rootNode = document.querySelector<HTMLElement>('#root');
      const hideEls = element.querySelectorAll<HTMLElement>(`.${CAPTURE_REMOVE_CLASS_NAME}`);
      const showEls = element.querySelectorAll<HTMLElement>(`.${CAPTURE_EXPEND_CLASS_NAME}`);
      document.body.style.height = 'auto';
      if (rootNode) {
        rootNode.style.height = 'auto';
      }
      hideEls.forEach((el) => {
        el.style.display = 'none';
      });
      showEls.forEach((el) => {
        if (!el) return;
        el.style.display = 'block';
        // @ts-ignore
        el.style['-webkit-box-orient'] = 'unset';
      });
      onclone?.(document, element);
    },
    ...remainOptions,
  });
  const imageFileSuffix = getImageFileSuffix(type);
  const dataURL = canvas.toDataURL(imageFileSuffix, 1);

  if (['png', 'image'].includes(type)) {
    downloadImage({
      url: dataURL,
      fileName: `${fileName}.${imageFileSuffix}`,
    });
  }
  if (type === 'pdf') {
    downloadPDF({
      url: dataURL,
      width: nodeOptions?.width || width,
      height: nodeOptions?.height || height,
      fileName,
    });
  }
};
